/**
 * 校区下拉展示排序工具（清账 F 项唯一排序事实源）。
 *
 * 独立于 api 模块存在：api 模块被大量 spec 以 vi.mock 工厂整模块替换，
 * 排序工具放 utils 可让组件直接用真实实现，无需逐 spec 补导出。
 */
export interface CampusSortItem {
  /** 校区数字码（4 位纯数字，学号前 4 位前缀） */
  numericCode?: string;
}

/**
 * 按 numericCode 升序返回新数组，不改入参。
 * 只负责排序、不做 ACTIVE 过滤；`?? ''` 为测试桩缺 numericCode 的运行时守卫，不抛错。
 */
export function sortCampusesByNumericCode<T extends CampusSortItem>(
  items: T[],
): T[] {
  return [...items].sort((a, b) =>
    (a.numericCode ?? '').localeCompare(b.numericCode ?? ''),
  );
}
